import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-bscard',
	templateUrl:'./BSCardPage.html',
	styles: [],
	styleUrls:['./BSCardPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSCardPage
{
	mdContent_77 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.cards.BSCard;
\`\`\``;
	mdContent_78 = `\`\`\`java
new BSCard<>()
\`\`\``;
	mdContent_79 = `\`\`\`java
new BSCard<>(String text)
\`\`\``;
	mdContent_80 = `\`\`\`java
new BSCard<>(boolean inverse)
\`\`\``;
	mdContent_81 = `\`\`\`java
var card = new BSCard<>();
card.addCardHeader("Featured");
var body = card.addCardBody();
body.addTitle(HeaderTypes.H5, "Card Title");
body.addText("Some quick example text.");
card.addFooter("Last updated 3 mins ago");
\`\`\``;
	mdContent_82 = `\`\`\`java
var card = new BSCard<>();
card.addCardImageTop("/images/banner.jpg");
card.addCardImageOverlay("Title", "Subtitle", "Overlay text here.");
\`\`\``;
}
